import { store } from "@src/index";

import {
    leagueManagementActions,
    selectSelectedLeague,
} from "@features/leaguemgmt/leagueManagementSlice";

import { getTeamSchedule } from "@lib/api";

const loader = async ({ params }: any) => {
    let { leagueId } = params;
    leagueId = parseInt(leagueId);

    let leagues = store.getState().leaguemanagement.leagues;
    const leaguesPromise = leagues.length
        ? Promise.resolve()
        : store.dispatch(leagueManagementActions.getLeagues());

    const selectedLeague = selectSelectedLeague(store.getState());

    const [{ schedule }] = await Promise.all([
        getTeamSchedule(params.leagueId, params.teamId),
        leaguesPromise,
    ]);

    if (selectedLeague?.id !== leagueId) {
        store.dispatch(leagueManagementActions.setSelectedLeague(leagueId));
    }

    return {
        schedule,
        teamName: schedule?.teamName || "Unknown Team",
    };
};

export default loader;
